import { apiGet, apiPost } from '../services/apiClient';

export const createDraftBooking = (payload, token) =>
  apiPost('/api/bookings/draft', payload, token);

export const addBookingAddons = (bookingId, payload, token) =>
  apiPost(`/api/bookings/${encodeURIComponent(bookingId)}/addons`, payload, token);

export const applyBookingCoupon = (bookingId, payload, token) =>
  apiPost(`/api/bookings/${encodeURIComponent(bookingId)}/apply-coupon`, payload, token);

export const applyBookingCardOffer = (bookingId, payload, token) =>
  apiPost(`/api/bookings/${encodeURIComponent(bookingId)}/card-offer`, payload, token);

export const saveGuestDetails = (bookingId, payload, token) =>
  apiPost(`/api/bookings/${encodeURIComponent(bookingId)}/guest`, payload, token);

export const confirmBooking = (bookingId, token, payload = {}) =>
  apiPost(`/api/bookings/${encodeURIComponent(bookingId)}/confirm`, payload, token);

export const getBookingById = (bookingId, token) =>
  apiGet(`/api/bookings/${encodeURIComponent(bookingId)}`, token);
